import { jwtDecode } from 'jwt-decode'

/**
 * JWT Token Payload Structure
 */
export interface JWTPayload {
  iss?: string
  aud?: string
  user?: {
    status?: string
    language?: string
    created?: string
    access?: string
    login?: number
    init?: string
    timezone?: string | null
    uid?: string
    qlnext_user_id?: string
    name?: string
    alias?: string
    email?: string
    phone?: string
    path?: string
    image?: string
    is_admin?: boolean
    permissions?: string[]
    roles?: string[]
    showroom_info?: unknown[]
    subscription?: unknown
    blocked_services?: Record<string, unknown>
    [key: string]: unknown
  }
  iat?: number
  exp?: number
  [key: string]: unknown
}

/**
 * Decode JWT token and return payload
 * @param token - JWT token string
 * @returns Decoded JWT payload or null if decoding fails
 */
export const decodeJWT = (token: string): JWTPayload | null => {
  try {
    if (!token || typeof token !== 'string') {
      return null
    }

    const decoded = jwtDecode<JWTPayload>(token)
    return decoded
  } catch (error) {
    console.error('Failed to decode JWT token:', error)
    return null
  }
}

/**
 * Extract roles from JWT token
 * @param token - JWT token string
 * @returns Array of roles or empty array if token is invalid or roles are missing
 */
export const extractRolesFromToken = (token: string): string[] => {
  const decoded = decodeJWT(token)
  if (!decoded?.user?.roles) {
    return []
  }

  // Ensure roles is an array
  if (Array.isArray(decoded.user.roles)) {
    return decoded.user.roles
  }

  return []
}

